export default "__VITE_ASSET__BXJv4FvV__"